import { tinyEditorTypes } from "../../enums/tinyEditorTypes";
import "./style.scss";
export default function BlockSelector({ onSelect }) {
  return (
    <div className="d-flex align-items-center justify-content-center gap-4 flex-wrap">
      <button
        className="block-btn"
        onClick={() => onSelect(tinyEditorTypes.TEXT)}
      >
        <i className="fa fa-font"></i>
        Text
      </button>
    </div>
  );
}
